<template>
    <v-navigation-drawer
        id="app-drawer"
        v-model="inputValue"
        app
        dark
        floating
        persistent
        :mobile-breakpoint="991"
        width="260"
    >
        <v-img :src="image" :gradient="sidebarOverlayGradiant" class="drawer-background" cover height="100%">
            <v-list class="fill-height">
                <v-list-item :to="'/home'" class="no-hover">
                    <v-list-item-title>
                        <v-img :src="logo" height="34" contain />
                        <!-- Spills & Complaints -->
                    </v-list-item-title>
                </v-list-item>
                <v-divider />

                <template v-if="spillsUserDto">
                    <v-list-item v-if="!!profile" :to="'/user-profile'" class="no-hover">
                        <template v-slot:prepend>
                            <v-avatar size="40">
                                <v-img :src="userProfilePicUrl" alt="avatar" class="img-responsive" />
                            </v-avatar>
                        </template>
                        <v-list-item-title id="profile_username">
                            <span>{{ userName }}</span>
                        </v-list-item-title>    
                    </v-list-item>

                    <template v-for="(link,i) in internalLinks" :key="i">
                        <template v-if="checkAccess(link.title)">
                            <template v-if="link.items">
                                <v-list-group v-model="link.active">
                                    <template v-slot:activator="{ props }">
                                        <v-list-item v-bind="props">
                                            <template v-slot:prepend>
                                                <v-icon color="white">{{ link.icon }}</v-icon>
                                            </template>
                                            <v-list-item-title style="color: white; font-size: 13px;">
                                                {{ link.text }}
                                            </v-list-item-title>
                                        </v-list-item>
                                    </template>
                                    <v-list-item
                                        v-for="subItem in link.items"
                                        :key="subItem.title"
                                        :to="subItem.to"
                                        :active-class="color"
                                    >
                                        <template v-slot:prepend>
                                            <v-icon color="white">
                                                {{ subItem.icon }}
                                            </v-icon>
                                        </template>
                                        <v-list-item-title style="color: white; font-size: 13px;">
                                            {{ subItem.text }}
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list-group>
                            </template>
                            <template v-else>
                                <v-list-item
                                    :key="'internalLinks' + i"
                                    :to="link.to"
                                    :active-class="color"
                                    avatar
                                    class="v-list-item"
                                >
                                    <template v-slot:prepend>
                                        <v-icon color="white">
                                            {{ link.icon }}
                                        </v-icon>
                                    </template>
                                    <v-list-item-title :style="{ color: 'white', fontSize: '13px' }">
                                        {{ link.text }}
                                    </v-list-item-title>
                                </v-list-item>
                            </template>
                        </template>
                    </template>
                </template>
                <v-list-item v-if="authenticated" @click="logout()" class="v-list-item">
                    <template v-slot:prepend>
                        <v-icon color="white">
                            mdi-logout
                        </v-icon>
                    </template>
                    <v-list-item-title :style="{ color: 'white', fontSize: '13px' }">
                        Log Out
                    </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="!authenticated" @click="login()" class="v-list-item">
                    <template v-slot:prepend>
                        <v-icon color="white">
                            mdi-login
                        </v-icon>
                    </template>
                    <v-list-item-title :style="{ color: 'white', fontSize: '13px' }">
                        Log In
                    </v-list-item-title>
                </v-list-item>
                <v-divider />

                <v-list-item
                    v-for="(link, i) in publicLinks"
                    :key="'publicLinks' + i"
                    :to="link.to"
                    :active-class="color"
                    class="v-list-item"
                >
                    <template v-slot:prepend>
                        <v-icon color="white">
                            {{ link.icon }}
                        </v-icon>
                    </template>
                    <v-list-item-title :style="{ color: 'white', fontSize: '13px' }">
                        {{ link.text }}
                    </v-list-item-title>
                </v-list-item>
                <!-- <v-list-item
                    active-class="primary"
                    class="v-list-item v-list__tile--buy"
                    to="/"
                >
                    <v-list-item-action>
                        <v-icon>mdi-package-up</v-icon>
                    </v-list-item-action>
                    <v-list-item-title class="font-weight-light">
                        Bottom Nav
                    </v-list-item-title>
                </v-list-item> -->
            </v-list>
        </v-img>
    </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapMutations, mapState } from 'vuex'
import userService from '@/services/userService'

export default {
    data: () => ({
        logo: '/img/deqlogo.png',
        bgImage: '/img/sidebar_bg_teton_1.jpg',
        publicLinks: [
            {
                title: 'incident-report',
                to: '/incident-report',
                icon: 'mdi-alert-octagon',
                text: 'Report a Spill'
            },
            {
                title: 'complaint',
                to: '/complaint',
                icon: 'mdi-clipboard-alert',
                text: 'Submit a Complaint'
            },
            {
                title: 'hcb-report',
                to: '/hcb-report',
                icon: 'mdi-alert-octagon',
                text: 'Report a Bloom'
            },
            {
                title: 'reports',
                to: '/reports',
                icon: 'mdi-file-document',
                text: 'Reports'
            }
        ],
        internalLinks: [
            {
                title: 'dashboard',
                to: '/dashboard',
                icon: 'mdi-view-dashboard',
                text: 'Dashboard',
                items: null
            },
            {
                title: 'incident-search',
                to: '/incident-search',
                icon: 'mdi-feature-search-outline',
                text: 'Incident Search',
                items: null
            },
            {
                title: 'complaint-search',
                to: '/complaint-search',
                icon: 'mdi-comment-search-outline',
                text: 'Complaint Search',
                items: null
            },
            {
                title: 'hcb-search',
                to: '/hcb-search',
                icon: 'mdi-feature-search-outline',
                text: 'Bloom Search',
                items: null
            },
            {
                title: 'internal-reports',
                to: '/internal-reports',
                icon: 'mdi-file-document-outline',
                text: 'Internal Reports',
                items: null
            },
            {
                title: 'email-templates',
                to: '/email-templates',
                icon: 'mdi-email-outline',
                text: 'Email Templates',
                items: null
            },
            {
                title: 'administration',
                to: '/',
                active: false,
                admin: true,
                text: 'Administration',
                items: [
                    {
                        title: 'user-admin',
                        to: '/user-administration',
                        icon: 'mdi-account',
                        text: 'User Admin'
                    }
                ]
            }
        ],
        responsive: false
    }),
    computed: {
        ...mapState('app', ['image', 'color']),
        ...mapState('auth', ['authenticated', 'spillsUserDto', 'profile']),
        inputValue: {
            get () {
                return this.$store.state.app.drawer
            },
            set (val) {
                this.setDrawer(val)
            }
        },
        items () {
            return this.$t('Layout.View.items')
        },
        sidebarOverlayGradiant () {
            return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor}`
        },
        userName: function () {
            return (this.profile && this.profile.name) ? this.profile.name : 'Unknown User'
        },
        userProfilePicUrl: function () {
            return (this.profile && this.profile.picture) ? this.profile.picture : ''
        },
        userEmail: function () {
            return (this.profile && this.profile.email) ? this.profile.email : ''
        },
        isAdmin: function () {
            return (this.spillsUserDto && userService.isAdministrator())
        },
        hasRoles: function () {
            return (this.spillsUserDto && userService.hasRoleList())
        }
    },
    mounted () {
        this.onResponsiveInverted()
        window.addEventListener('resize', this.onResponsiveInverted)
    },
    beforeUnmount () {
        window.removeEventListener('resize', this.onResponsiveInverted)
    },
    methods: {
        ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
        onResponsiveInverted () {
            if (window.innerWidth < 991) {
                this.responsive = true
            } else {
                this.responsive = false
            }
        },
        login () {
            this.$auth.login()
        },
        logout () {
            this.$auth.logout()
        },
        checkAccess (menuTitle) {
            switch (menuTitle) {
            case 'administration':
                return this.isAdmin
            default:
                return this.hasRoles
            }
        }
    }
}
</script>


<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    // .v-image__image--contain {
    // //   top: 9px;
    // //   height: 60%;
    // }

    .v-divider {
        margin: 10px auto 10px;
    }

    div.v-responsive.v-image > div.v-responsive__content {
      overflow-y: auto;
    }

    #profile_username {
        color: white !important;
        font-size: 16px !important;
        height: auto;
        white-space: normal;
    }

    .no-hover .v-list__tile--link:hover {
        background-color: transparent;
    }

    .v-list-group__header .v-icon {
        color: white !important;
    }
  }
</style>
